import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../../localization/labels";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import IndividualService from "../../../../../services/IndividualService";
import InvolvementRoleTypeService from "../../../../../services/InvolvementRoleTypeService";
import PartyRoleService from "../../../../../services/PartyRoleService";
import PartyRoleTypeService from "../../../../../services/PartyRoleTypeService";
import CommonUtil from "../../../../../utils/CommonUtil";
import PathUtil from "../../../../../utils/PathUtil";
import {
  individualValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import { paths } from "../../../../paths";
import PageComponent from "../../../page/PageComponent";
import PartyRoleDetail from "./PartyRoleDetail";
import OrganisationService from "../../../../../services/OrganisationService";

class PartyRoleDetailContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.partyRoleService = new PartyRoleService(this.keycloak);
    this.partyRoleTypeService = new PartyRoleTypeService(this.keycloak);
    this.involvementRoleTypeService = new InvolvementRoleTypeService(
      this.keycloak
    );
    this.individualService = new IndividualService(this.keycloak);
    this.organisationService = new OrganisationService(this.keycloak);

    this.sortInfo = {
      orderBy: "name",
      direction: "asc"
    };
    this.state = {
      id: this.resolveItemId(),
      partyId: PathUtil.pathParameter(this.props, "partyId"),
      organisationId: PathUtil.pathParameter(this.props, "organisationId")
    };
    this.state = this.initialState(this.state);
  }

  initialState = state => {
    return {
      ...state,
      disabled: true,
      entity: {
        name: undefined,
        dateFromTo: {
          dateFrom: undefined,
          dateTo: undefined
        },
        partyRoleType: undefined
      },
      involvementRoleTypes: [],
      parentInvolvementRoleTypes: [],
      partyRoleTypes: [],
      individual: {
        name: undefined,
        lastName: undefined
      },
      organisation: {
        name: undefined
      }
    };
  };

  componentDidUpdate(prevProps) {
    const newId = this.resolveItemId();

    if (newId !== PathUtil.pathParameter(prevProps, "id")) {
      this.state.id = newId;
      this.state.partyId = PathUtil.pathParameter(this.props, "partyId");
      this.state.organisationId = PathUtil.pathParameter(this.props, "partyId");

      this.setState(this.initialState(this.state));
      this.loadData();
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  loadData = () => {
    if (this.state.id) {
      this.loadSelectedEntity(this.state.id);
    }
    if (this.state.partyId) {
      this.loadIndividual(this.state.partyId);
    }
    if (this.state.organisationId) {
      this.loadOrganisation(this.state.organisationId);
    }

    this.loadRoleTypes();
  };

  loadIndividual = partyId => {
    this.prepareCall(
      this.individualService.getEntityById(
        partyId,
        this.onIndividualLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadOrganisation = organisationId => {
    this.prepareCall(
        this.organisationService.getEntityById(
            organisationId,
            this.onOrganisationLoad,
            this.messageHandler.handleError
        )
    );
    this.performCalls();
  };

  onIndividualLoad = data => {
    this.setState({ individual: data });

    if (!this.state.id) {
      this.setComponentTitle(labels.partyRole);
    }
  };

  onOrganisationLoad = data => {
    this.setState({ organisation: data });

    if (!this.state.id) {
      this.setComponentTitle(labels.partyRole);
    }
  };

  getComponentTitle = () => {
    return this.state.entity ? this.state.entity.name : undefined;
  };

  loadSelectedEntity = id => {
    this.prepareCall(
      this.partyRoleService.getEntityById(
        id,
        this.onSelectedEntityLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onSelectedEntityLoad = data => {
    this.state.partyId = data.partyId;
    this.state.organisationId = data.organisationId;
    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      disabled: false
    });
    this.setComponentTitle(this.state.entity.name, true);

    this.loadEntityPartyRoleType(data);
  };

  loadEntityPartyRoleType = data => {
    const url = data._links.partyRoleType.href;
    this.prepareCall(
      this.partyRoleTypeService.getEntitiesByUrl(
        url,
        this.onEntityPartyRoleTypeLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntityPartyRoleTypeLoad = data => {
    const { entity, oldEntity } = this.state;
    entity["partyRoleType"] = data;
    oldEntity["partyRoleType"] = data;
    this.setState({ entity, oldEntity });

    this.loadEntityPartyRoleTypeInvolvementRoleTypes(data);
    this.loadEntityParentPartyRoleTypeInvolvementRoleTypes(data);
  };

  loadEntityPartyRoleTypeInvolvementRoleTypes = data => {
    const url = data._links.involvementRoleTypes.href;
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesByUrl(
        url,
        this.onEntityPartyRoleTypeInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadEntityParentPartyRoleTypeInvolvementRoleTypes = data => {
    const url = data._links.parentInvolvementRoleTypes.href;
    this.prepareCall(
      this.involvementRoleTypeService.getEntitiesByUrl(
        url,
        this.onParentEntityPartyRoleTypeInvolvementRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntityPartyRoleTypeInvolvementRoleTypesLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      let { involvementRoleTypes } = this.state;
      involvementRoleTypes = dataContent;
      this.setState({ involvementRoleTypes });
    } else {
      this.setState({ involvementRoleTypes: [] });
    }
  };

  onParentEntityPartyRoleTypeInvolvementRoleTypesLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      let { parentInvolvementRoleTypes } = this.state;
      parentInvolvementRoleTypes = dataContent;
      this.setState({ parentInvolvementRoleTypes });
    } else {
      this.setState({ parentInvolvementRoleTypes: [] });
    }
  };

  loadRoleTypes = () => {
    this.prepareCall(
      this.partyRoleTypeService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onRoleTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRoleTypesLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      this.setState({ partyRoleTypes: dataContent });
    }
  };

  onChange = event => {
    let { entity } = this.state;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(entity, path, event.target.value);
    const disabled = !this.validator(entity);
    this.setState({ entity, disabled });
    if (event.target.id === "partyRoleType") {
      this.loadEntityPartyRoleTypeInvolvementRoleTypes(event.target.value);
    }
  };

  validator = entity => {
    return validateEntity(entity, validationRules.partyRoles);
  };

  onSave = event => {
    const { entity } = this.state;
    if (!this.state.id) {
      this.createPartyRole(entity);
    } else {
      this.updatePartyRole(entity);
    }
  };

  updatePartyRole = entity => {
    this.prepareCall(
      this.partyRoleService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onDataSaveResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  createPartyRole = entity => {
    if (this.state.partyId !== undefined) {
      entity = {...entity, party: this.state.individual};
    } else {
      entity = {...entity, party: this.state.organisation};
    }

    this.prepareCall(
      this.partyRoleService.postEntity(
        entity,
        this.onDataSaveResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  onDataSaveResponse = data => {
    let path;
    let partyId;

    if (this.state.organisationId !== undefined) {
      path = paths.ORGANISATIONS;
      partyId = this.state.organisationId;
    } else {
      path = paths.INDIVIDUALS;
      partyId = this.state.partyId;
    }

    if (this.state.id) {
      this.loadSelectedEntity(this.state.id);
    } else {
      const itemPath = PathUtil.adminItemsPath(
          {
            path: path,
            partyId: partyId
          },
          {
            path: paths.PARTYROLES,
            id: data.id
          }
      );
      this.changePath(itemPath, data.name);
    }
  };

  render() {
    const maxLength = {
      name: 255
    };
    if (
        !this.state.entity.partyId ||
        this.state.entity.partyId === this.state.partyId ||
        this.state.entity.organisationId === this.state.organisationId
    ) {
      return (
        <PartyRoleDetail
          {...this.renderProps()}
          individual={this.state.individual}
          entity={this.state.entity}
          maxLength={maxLength}
          validationRule={validationRules.partyRoles}
          partyRoleTypes={this.state.partyRoleTypes}
          onChange={this.onChange}
          onSave={this.onSave}
          disabled={this.state.disabled}
          {...this.handlerProps()}
          isNew={this.state.id ? false : true}
          involvementRoleTypes={this.state.involvementRoleTypes}
          parentInvolvementRoleTypes={this.state.parentInvolvementRoleTypes}
        />
      );
    } else {
      return null;
    }
  }
}

export default withKeycloak(PartyRoleDetailContainer);
